import { useModuleEndpoint } from './useModuleEndpoint';

export function useModuleConfig(moduleId: number, subpath = '') {
  const {
    response: moduleConfig = {},
    getEndpoint: fetchModuleConfig,
    isFetching,
    hasJustFinishedFetching,
    error: configError,
  } = useModuleEndpoint(moduleId, `${subpath}/config`);

  const {
    postEndpoint: saveModuleConfig,
    isFetching: isSaving,
    hasJustFinishedFetching: hasJustFinishedSaving,
    error: saveError,
  } = useModuleEndpoint(moduleId, `${subpath}/save`);

  return {
    error: saveError || configError,
    isSaving,
    isFetching,
    moduleConfig,
    saveModuleConfig,
    fetchModuleConfig,
    hasJustFinishedFetching,
    hasJustFinishedSaving,
  };
}
